"use client";

import useMediaQuery from "@core/helpers/client/hooks/useMediaQuery";

// Below Tailwind's `lg:` (1024px). From chawk-bazar and jument `useIsMobile` ("(max-width: 1023px)", false on the server).
// options:
// - breakpoint: the first desktop width. A number (px) gives "(max-width: <n-1>px)"; a CSS length ("64rem") gives
//   "not all and (min-width: 64rem)". Default 1024.
// - query: a full media query instead of the breakpoint.
// - server_value: value on the server and during hydration. Default false (the desktop branch).
export default function useIsMobile({ breakpoint = 1024, query, server_value = false } = {}) {
	const media =
		query ||
		(typeof breakpoint === "number" ? `(max-width: ${breakpoint - 1}px)` : `not all and (min-width: ${breakpoint})`);
	return useMediaQuery(media, { server_value });
}
